<div class="govuk-width-container">
  <gb-ui-header
    [imageDetail]="imageDetail"
    [showSearch]="true"
    [navLinks]="navigation"
    (searchTerm)="search($event)"
  >
  </gb-ui-header>
</div>
